<template>
    <div class="collect-page">
        <!-- 顶部标题栏 -->
        <div class="page-header">
            <div>
                <span class="title">收藏夹</span>
                <el-input v-model="formDatas.chatTitle" style="width: 150px;margin-left: 15px;" size="small"
                    placeholder="标题" clearable></el-input>
                <el-button icon="el-icon-search" @click="partserch" size="small"></el-button>
            </div>

            <button class="close-btn" @click="goBack">
                关闭
            </button>

        </div>

        <!-- 卡片列表容器 -->
        <div style="width: 98%;margin: 10px auto;height: calc(100% - 140px);overflow-y: auto;">
            <div class="card-list">
                <!-- 单个收藏卡片（循环渲染） -->
                <div class="collect-card" v-for="(item, index) in tableData" :key="index" @click="handleDetail(item)">
                    <!-- 卡片内容区域 -->
                    <div class="card-content">
                        <!-- 图片封面（有图片显示图片，无图片显示文本） -->
                        <div class="text-content">
                            <p class="card-title title-ellipsis">{{ item.chatTitle }}</p>
                            <p class="card-desc">{{ item.chatSummary || '' }}</p>

                        </div>
                    </div>
                    <!-- 卡片底部操作栏 -->
                    <div class="card-actions">
                        <!-- 编辑模式显示删除，非编辑模式显示更多 -->
                        <button class="action-btn" @click.stop="handleDetail(item)">
                            <span>查看详情</span>
                        </button>
                        <button class="action-btn" style="color: red;" @click.stop="handleDelete(item)">
                            <span>取消收藏</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-pagination" style="background-color: #f5f5f5;">
            <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
                :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
        </div>
    </div>
</template>


<script>
import { getAiUserChatCollectionList, deleteAiUserChatCollection } from "../../api/api";
export default {
    name: "CollectList",
    data() {
        return {
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 15,
            },
            totalCount: 10,
            // 编辑模式开关
            isEdit: false,
            // 收藏列表数据（匹配截图中的内容）
            collectList: [

            ]
        };
    },
    created() {
        this.partserch()
    },
    methods: {
        handleDetail(row) {
            console.log("点击卡片，跳转/查看详情：", row);
            const { href } = this.$router.resolve({
                name: 'collectDetail',
                query: {
                    id: row.auccId,
                }
            });
            window.open(href, '_blank');
        },
        handleDelete(row) {
            deleteAiUserChatCollection({
                auccId: row.auccId,
            }).then(res => {
                if (res.status == 200) {
                    this.partserch()
                }
            })
        },
        goBack() {
            this.$router.go(-1);
            setTimeout(() => {
                window.location.reload();
            }, 100); // 短延迟确保先完成路由回退
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAiUserChatCollectionList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAiUserChatCollectionList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        // 切换编辑/完成状态
        toggleEdit() {
            this.isEdit = !this.isEdit;
        },
        // 操作按钮点击（更多/删除）
        handleActionClick(item) {
            if (this.isEdit) {
                // 编辑模式：删除卡片
                this.collectList = this.collectList.filter(item => item.id !== item.id);
                console.log("删除收藏项：", item);
            } else {
                // 非编辑模式：更多操作（比如分享、置顶等）
                console.log("更多操作：", item);
                // 可添加弹窗、下拉菜单等逻辑
            }
        }
    }
};
</script>

<style scoped>
.close-btn {
    /* 朴素基础样式：无背景、无边框、仅文字 */
    border: none;
    /* background: transparent; */
    font-size: 14px;
    color: #666;
    /* 中性灰色，更朴素 */
    cursor: pointer;
    padding: 4px 15px;
    border-radius: 20px;
    border: 1px solid #909399;
    /* 轻微圆角，不突兀 */
    transition: background-color 0.2s;
}

/* 悬浮仅轻微变浅，保持朴素 */
.close-btn:hover {
    background-color: #f0f0f0;
    color: #333;
}

/* 编辑状态下按钮样式微调（可选，区分状态） */
.close-btn:active {
    background-color: #e5e5e5;
}

.ve-pagination {
    background: none !important;
}

/* 页面整体样式 */
.collect-page {
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    padding: 16px;
    box-sizing: border-box;
}

/* 顶部标题栏 */
.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
    height: 40px;
}

.page-header .title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.page-header .edit-btn {
    font-size: 14px;
    color: #1989fa;
    cursor: pointer;
}

/* 卡片列表 */
.card-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
    gap: 16px;
}

/* 单个卡片样式 */
.collect-card {
    background-color: #fff;
    border-radius: 8px;
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); */
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.2s;
    border: 1px solid #e0e0e0;
}

.collect-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 卡片内容区域 */
.card-content {
    width: 100%;
    height: 180px;
    overflow: hidden;
}

/* 图片封面 */
.card-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* 文本内容（无图片时显示） */
.text-content {
    width: 100%;
    height: 100%;
    padding: 16px;
    box-sizing: border-box;

}

/* 文本超出省略处理 */
.title-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-title {
    font-size: 15px;
    font-weight: 500;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
    margin: 0 0 8px 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    padding-bottom: 10px;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.card-desc {
    font-size: 13px;
    color: #909399;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.5;
}

/* 卡片操作栏 */
.card-actions {
    padding: 8px 16px;
    border-top: 1px solid #f0f0f0;
    text-align: right;
}

.action-btn {
    border: none;
    background: none;
    font-size: 13px;
    color: #1989fa;
    cursor: pointer;
    padding: 4px 8px;
}

.action-btn:hover {
    color: #0066cc;
}
</style>